export function FeatureLocked({ feature, description }) {
  return (
    <div class="feature-locked">
      <div class="feature-locked-content">
        <div class="lock-icon">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
          </svg>
        </div>
        <h2>{feature} is not available in your plan</h2>
        {description && <p class="feature-desc">{description}</p>}
        <p class="upgrade-text">Upgrade your plan to unlock this feature and more.</p>
        <a href="/upgrade" class="upgrade-btn">View Plans</a>
      </div>

      <style>{`
        .feature-locked {
          display: flex;
          align-items: center;
          justify-content: center;
          min-height: 400px;
          padding: 2rem;
        }

        .feature-locked-content {
          text-align: center;
          max-width: 400px;
        }

        .lock-icon {
          color: #9CA3AF;
          margin-bottom: 1.5rem;
        }

        .feature-locked h2 {
          margin: 0 0 0.75rem;
          font-size: 1.5rem;
          color: #111827;
        }

        .feature-desc {
          color: #6B7280;
          margin: 0 0 1rem;
          font-size: 0.875rem;
        }

        .upgrade-text {
          color: #6B7280;
          margin: 0 0 1.5rem;
        }

        .upgrade-btn {
          display: inline-block;
          background: #4F46E5;
          color: white;
          padding: 0.75rem 1.5rem;
          border-radius: 8px;
          font-weight: 500;
          text-decoration: none;
          transition: background 0.2s;
        }

        .upgrade-btn:hover {
          background: #4338CA;
        }
      `}</style>
    </div>
  );
}

// Wrapper component for pages that require a feature
export function RequireFeature({ feature, featureName, description, children }) {
  // Import useAuth inline to avoid circular dependency issues
  const { hasFeature } = require('../lib/auth').useAuth();

  if (!hasFeature(feature)) {
    return <FeatureLocked feature={featureName || feature} description={description} />;
  }

  return children;
}
